import React from "react";

/**
 * THE APP HAD NO ERROR BOUNDARY ANYWHERE.
 *
 * That is the real defect behind the two crashes found on 2026-08-13. `golfer.first_name[0]`
 * and `fitting.fitting_type.toUpperCase()` were where it surfaced, but the reason a single
 * malformed customer record could take down the ENTIRE application — measured, `#root`
 * innerHTML length 0, a white screen — is that React unmounts the whole tree when a render
 * throws and nothing was there to catch it.
 *
 * Guarding those two expressions fixes those two records. This fixes the class: from here a bad
 * record breaks its own row, or at worst its own panel, and the rest of the app keeps working.
 *
 * DELIBERATELY NOT A RETRY LOOP. `resetKey` lets a parent clear the error when the thing that
 * failed genuinely changes — a different view, a different record. Re-rendering the same broken
 * subtree on a timer would just throw again, and a boundary that flickers is worse than one
 * that states the problem and stops.
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // Logged, never swallowed. A contained failure that nobody can see is still a failure, and
    // the smoke suite asserts on console errors precisely so this shows up in CI.
    // eslint-disable-next-line no-console
    console.error(`ErrorBoundary(${this.props.label || "unlabelled"}):`, error, info);
  }

  componentDidUpdate(prevProps) {
    if (this.state.error && prevProps.resetKey !== this.props.resetKey) {
      this.setState({ error: null });
    }
  }

  render() {
    if (!this.state.error) return this.props.children;

    if (this.props.fallback) return this.props.fallback;

    return (
      <div className="content error-boundary" data-testid="error-boundary">
        <h2>Something on this screen could not be displayed</h2>
        <p>
          The rest of the Hub is still working — use the menu to carry on. If this keeps
          happening, tell Henry-Griffitts which screen you were on.
        </p>
        <p className="error-boundary-detail" data-testid="error-boundary-detail">
          {String(this.state.error?.message || this.state.error)}
        </p>
      </div>
    );
  }
}

export default ErrorBoundary;
